import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-freman-privacy-policy',
  templateUrl: './freman-privacy-policy.component.html',
  styleUrls: ['./freman-privacy-policy.component.scss']
})
export class FremanPrivacyPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
